import script from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=78a47ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a47ae8"]])

export default __exports__